import React from 'react';
import PropTypes from 'prop-types';
import { formatDate } from 'shared/date';

const DateCell = ({ value }) => <span>{formatDate(value, 'L')}</span>;

DateCell.propTypes = { value: PropTypes.string.isRequired };

export default DateCell;
